import { render } from "./TopWorst.vue?vue&type=template&id=6c53cd7d&scoped=true"
import script from "./TopWorst.vue?vue&type=script&lang=js"
export * from "./TopWorst.vue?vue&type=script&lang=js"

import "./TopWorst.vue?vue&type=style&index=0&id=6c53cd7d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c53cd7d"]])

export default __exports__